const mui = {
  MuiToolBar: {
    defaultProps: {
      sx: {
        height: "100%",
      },
    },
  },
};
export default mui;
